module.exports = __webpack_public_path__ + "static/media/icon_done.44744ac1.svg";